module.exports = __webpack_public_path__ + "img/sanquamulti.26306c5d.png";